import React, {useEffect, useState } from 'react';
import ReactDOM from "react-dom";
import './UsersTicket.model.css'
import 'bootstrap/dist/css/bootstrap.css'
import { ConfigProvider } from "antd";
import { DatePicker as DatePickerJalali, JalaliLocaleListener, useJalaliLocaleListener } from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";
import { Select } from 'antd';
import { getLabList } from "../../api/api";
import { getParsicUser } from "../../api/api";
import { getSupportTicketList } from "../../api/api";
import { errorNotify } from "../../services/toast.notification";
import Spinner from "../../components/_common/Spinner";


// export interface InputProps {
//     fromDate:any,
//     toDate:any
// }

//{fromDate,toDate}:InputProps
const UsersTicket = () => {

    const [firstDate,setFirstDate] = useState<any>();
    const [lastDate,setLastDate] = useState<any>();
    const [isLoading,setIsLoading] = useState(false);
    const [LabData,setLabData] = useState([]);
    const [UserData,setUserData] = useState([]);
    const [supportList,setSupportList] = useState([]);
    const [selectedLab,setSelectedLab] = useState(0);
    const [selectedUser,setSelectedUser] = useState(0);
    const [selectedState,setSelectedState] = useState(0);
    const [selectedType,setSelectedType] = useState(0);

    const onChangeDatePicker = (dates:any,dateStrings:any,info:any) => {

        console.log(dates);
        if (!dateStrings) return;
        if (dateStrings.length < 2) return;
        if (dateStrings[0] === "") return;
        if (dateStrings[1] === "") return;

        debugger
        setFirstDate(dates[0])
        setLastDate(dates[1])

    }

    const _getLabList = () => {
        setIsLoading(true);
        getLabList()
        .then((result:any) => {
            setLabData(result.data.data);
            setIsLoading(false);
            //console.log('backup info is: '+ result.data.json);
        })
        .catch((error) => {
            console.log(error);
            errorNotify(error.response.data.errorMessage,undefined,5000)
        }) 
    }

    const _getParsicUser = () => {
        setIsLoading(true);
        getParsicUser()
        .then((result:any) => {
            debugger
            setUserData(result.data.data);
            setIsLoading(false);
            //console.log('backup info is: '+ result.data.json);
        })
        .catch((error) => {
            console.log(error);
            errorNotify(error.response.data.errorMessage,undefined,5000)
        }) 
    }

    const searchTicketList = () => {
        setIsLoading(true);
        getSupportTicketList(firstDate.format("YYYY-MM-DD") , lastDate.format("YYYY-MM-DD") , selectedLab , selectedUser , selectedState , selectedType)
        .then((result:any) => {
            debugger
            setSupportList(result.data);
            setIsLoading(false);
            //console.log('backup info is: '+ result.data.json);
        })
        .catch((error) => {
            console.log(error);
            errorNotify(error.response.data.errorMessage,undefined,5000)
        }) 
    }

    useEffect(() => {
       _getLabList();
       _getParsicUser();
    }, []);
    return (
        <div className='container UsersTicket'>
            <div className='card'>
                <div className='card-body'>
                    <div className='row'>
                        <div className="col-md-4 mb-4 calender">
                            <label className="form-label">بازه تاریخی</label> 
                            <ConfigProvider locale={fa_IR} direction="rtl">
                                <JalaliLocaleListener />
                                <DatePickerJalali.RangePicker value={[firstDate,lastDate]}  onCalendarChange={(dates:any,dateStrings:any,info:any)=>onChangeDatePicker(dates,dateStrings,info)} />
                            </ConfigProvider>
                        </div>
                        <div className="col-md-4 mb-4">
                            <label htmlFor="slcLab" className="form-label">آزمایشگاه</label> 
                            <Select
                                className='antdComboStyle'
                                showSearch
                                optionFilterProp="label"
                                placeholder="انتخاب کنید"
                                options={LabData.map((item: any) => ({
                                    value: item.prk_AndriodLab_AutoID ,
                                    label: item.str_LabPersianName
                                }))}
                                onChange={(value) => setSelectedLab(value)}
                            />
                        </div>
                        <div className="col-md-4 mb-4">
                            <label htmlFor="slcLab" className="form-label">کاربر مربوطه</label> 
                            <Select
                                className='antdComboStyle'
                                showSearch
                                optionFilterProp="label"
                                placeholder="انتخاب کنید"
                                options={UserData.map((item:any) =>({
                                    value: item.prk_ParsicUser_AutoID,
                                    label: item.str_FullName
                                }))}
                                onChange={(value) => setSelectedUser(value)}
                            />
                        </div>
                        <div className="col-md-4 mb-4">
                            <label className="form-label">وضعیت</label> 
                            <Select
                                className='antdComboStyle'
                                showSearch
                                optionFilterProp="label"
                                placeholder="انتخاب کنید"
                                options={[
                                    { value: 1, label: 'همه' },
                                    { value: 2, label: 'انجام شده' },
                                    { value: 3, label: 'در حال بررسی' },
                                ]}
                                onChange={(value) => setSelectedState(value)}
                            />
                        </div>
                        <div className="col-md-4 mb-4">
                            <label className="form-label"> جستجو بر اساس</label> 
                            <Select
                                className='antdComboStyle'
                                showSearch
                                optionFilterProp="label"
                                placeholder="انتخاب کنید"
                                options={[
                                    { value: 1, label: 'تاریخ تیکت' },
                                    { value: 2, label: 'تاریخ بسته شدن تیکت' },
                                ]}
                                onChange={(value) => setSelectedType(value)}
                            />
                        </div>
                        <div className='col-md-12 d-flex justify-content-end'>
                            <button type="button" className="ant-btn ant-btn-primary" onClick={searchTicketList}>جستجو</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                {  isLoading === false  && (
                <div className='card-body'>
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>ردیف</th>
                                    <th>عنوان</th>
                                    <th>زمان</th>
                                    <th>گروه</th>
                                    <th>شرح</th>
                                </tr>
                            </thead>
                            <tbody className="table-border-bottom-0">
                                {
                                    supportList.map((item: any , index) => (
                                        <tr>
                                            <td data-label="ردیف">{index + 1}</td>
                                            <td data-label="عنوان">{item.Str_TicketTitle}</td>
                                            <td data-label="زمان">{item.Str_DisplayDateTime}</td>
                                            <td data-label="گروه">{item.str_TicketType}</td>
                                            <td data-label="شرح">{item.Str_TicketDescription}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                )}
                {
                    isLoading === true  && (<Spinner />)
                }
            </div>
        </div>
    );
};

export default UsersTicket